export const calendarTheme = {
	color: 'blue',
	isDark: false,
	container: {
		light:
			'',
		dark:
			'',
	},
	header: {
		light: '',
		dark: '',
	},
	title: {
		light: 'uk-date-indicator uk-border-rounded-small uk-text-center',
		dark: '',
	},
	arrows: {
		light: 'vc-arrows',
		dark: '',
	},
	weekdays: {
		light: 'uk-text-muted uk-text-overline',
		dark: '',
	},
	navPopoverContainer: {
		light:
			'vc-rounded-lg vc-text-sm vc-font-semibold vc-text-white vc-bg-gray-800 vc-border vc-border-gray-700 vc-p-1 vc-shadow',
		dark:
			'vc-rounded-lg vc-text-sm vc-font-semibold vc-text-gray-800 vc-bg-white vc-border vc-border-gray-100 vc-p-1 vc-shadow',
	},
	navTitle: {
		light:
			'vc-text-{color}-100 vc-font-bold vc-leading-snug vc-px-2 vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-900 focus:vc-border-{color}-600',
		dark:
			'vc-text-gray-900 vc-font-bold vc-leading-snug vc-px-2 vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-200 focus:vc-border-{color}-400',
	},
	navArrows: {
		light:
			'vc-leading-snug vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-900 focus:vc-border-{color}-600',
		dark:
			'vc-leading-snug vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-200 focus:vc-border-{color}-400',
	},
	navCell: {
		light:
			'vc-w-12 vc-font-semibold vc-cursor-pointer vc-text-center vc-leading-snug vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-900 hover:vc-shadow-inner hover:vc-text-white focus:vc-border-{color}-600',
		dark:
			'vc-w-12 vc-font-semibold vc-cursor-pointer vc-text-center vc-leading-snug vc-py-1 vc-rounded vc-border-2 vc-border-transparent hover:vc-bg-gray-200 hover:vc-text-gray-900 focus:vc-border-{color}-400',
	},
	navCellInactive: 'vc-border-transparent',
	navCellInactiveCurrent: {
		light: 'vc-text-{color}-100 vc-font-bold vc-border-{color}-100',
		dark: 'vc-text-{color}-600 vc-font-bold vc-border-{color}-500',
	},
	navCellActive: {
		light:
			'vc-bg-{color}-100 vc-text-{color}-900 vc-border-transparent vc-font-bold vc-shadow',
		dark:
			'vc-bg-{color}-500 vc-text-white vc-border-transparent vc-font-bold vc-shadow',
	},
	dayNotInMonth: 'vc-dayNotInMonth',
	dayContent: 'uk-text-small',
	dayContentDisabled: {
		light: '',
		dark: '',
	},
	dayPopoverContainer: {
		light:
			'vc-rounded uk-text-left vc-text-xs vc-text-white vc-font-medium vc-bg-gray-800 vc-border vc-border-gray-700 vc-px-2 vc-py-1 vc-shadow',
		dark:
			'vc-rounded uk-text-left vc-text-xs vc-text-gray-900 vc-font-medium vc-bg-white vc-border vc-border-gray-200 vc-px-2 vc-py-1 vc-shadow',
	},
	dayPopoverHeader: {
		light: 'vc-text-xs vc-text-gray-300 vc-font-semibold',
		dark: 'vc-text-xs vc-text-gray-700 vc-font-semibold',
	},
	highlightBaseFillMode: 'light',
	highlightStartEndFillMode: 'solid',
	highlightStartEndClass: 'highlightStartEndClass',
	bgLow: {
		light: 'bgLow',
		dark: '',
	},
	bgAccentLow: {
		light: 'bgAccentLow vc-border-highlight vc-bg-white',
		dark: '',
	},
	bgAccentHigh: {
		light: 'bgAccentHigh vc-bg-{color} uk-border-rounded-small',
		dark: '',
	},
	contentAccent: {
		light: 'contentAccent',
		dark: '',
	},
	contentAccentContrast: 'uk-border-rounded-small vc-text-contrast-{color}',
	datePickerInput: 'vc-datePickerInput uk-input uk-form-small',
	datePickerInputDrag:'uk-input uk-form-small',


};
